<div class="auth login">
  <div class="auth__header flex flex-col gap-4 text-center">
    <h2 translate>Login</h2>
    <p [translate]="
        authModalService.loginDescription || 'Enter Your Email And Password'
      "></p>
  </div>
  <form class="flex flex-col gap-4" [formGroup]="form" (submit)="submit()">
    <input-text [options]="{
        label: 'User Name Or Email',
        control: form.controls.userName,
        isShowErrors,
      }"></input-text>
    <div class="password__wrapper">
      <input-password [options]="{
          label: 'Password',
          control: form.controls.password,
          isShowErrors,
        }"></input-password>
      <app-anchor class="" to="forget-password" text="Forget Password?" [preventIf]="authModalService.isInModal"
        (onClick)="authModalService.goForgetPassword()"></app-anchor>
    </div>


    <div class="w-full flex justify-center">
      <input-recaptcha [options]="{
          control: form.controls.recaptcha,
          isShowErrors: isShowErrors,
        }"></input-recaptcha>
    </div>

    <button type="submit" class="primary__btn" translate>Login</button>
  </form>
  <p class="account__status text-center mt-10">
    {{ "Don’t Have Account ?" | translate }}
    <app-anchor to="sign-up" text="Create Account" [preventIf]="authModalService.isInModal"
      (onClick)="authModalService.goSignUp()"></app-anchor>
  </p>

  <div class="mt-10">
    <app-openid-authentication></app-openid-authentication>
  </div>
</div>